/* eslint-disable no-unused-vars */

import React from 'react';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as rb from 'react-bootstrap';

class Map extends React.Component {
  constructor(props) {
    super();
    this.state = {
      country:"",
      redirect2Story:false,
      cur_scrollPosition: 550
    };
    window.scrollTo('50%', '50%');
    this.toLeft = this.toLeft.bind(this);
    this.toRight = this.toRight.bind(this);
    this.searchCountry = this.searchCountry.bind(this);
  }

  componentDidMount() {
    var elmnt = document.getElementById("mapScroll");
    elmnt.scrollLeft = this.state.cur_scrollPosition;
  }

  toLeft(){
    var scrollPosition = this.state.cur_scrollPosition;
    if(scrollPosition > 0){
      scrollPosition = scrollPosition - 50;
      var elmnt = document.getElementById("mapScroll");
  
      elmnt.scrollLeft = scrollPosition;
      this.setState({cur_scrollPosition:scrollPosition});
    }
   
  }

  toRight(){
    var scrollPosition = this.state.cur_scrollPosition;
    if(scrollPosition <= 950){
      scrollPosition = scrollPosition + 50;
      console.log(scrollPosition);
      var elmnt = document.getElementById("mapScroll");
  
      elmnt.scrollLeft = scrollPosition;
      this.setState({cur_scrollPosition:scrollPosition});
    }
   
  }

  searchCountry(val){
    this.setState({country:val, redirect2Story: true});
  }

  render() {
    if(this.state.redirect2Story){
      return <Redirect to={`/stories?Country=${this.state.country}`} />
    }
    return (
      <div className="Map">
        <div className="container-fluid app-map p-0 position-relative">
          <div className="position-absolute map-arrows" style={{ top: '50%', 'left': '0px', zIndex :99 }} onClick={this.toLeft}>
            <img src="./images/slideLeft.png" />
          </div>
          <div className="position-absolute map-arrows" style={{ top: '50%', 'right': '0px', zIndex :99  }} onClick={this.toRight}>
            <img src="./images/slideRight.png" />
          </div>
          <div className="row m-0">
            <div className="col-md-12 p-0 overflow-auto position-relative" id="mapScroll">
              <img src="images/slice/1.homepage/map/map.png" />

              <div className="map-dots position-absolute" style={{ top: '190px', 'left': '284px' }} onClick={()=>this.searchCountry(4)}>
                <div className="position-relative">
                  <div className="countryName">INDIA</div>
                  <div className="position-absolute" style={{ left: '-6px', top: '-1px' }}>
                    <img src="images/slice/1.homepage/map/location.png" />
                  </div>
                </div>
              </div>
              <div className="map-dots position-absolute" style={{ top: '170px', 'left': '575px' }} onClick={()=>this.searchCountry(8)}> 
                <div className="position-relative">
                  <div className="countryName">MYANMAR</div>
                  <div className="position-absolute" style={{ left: '-6px', top: '-1px' }}>
                    <img src="images/slice/1.homepage/map/location.png" />
                  </div>
                </div>
              </div>
              <div className="map-dots position-absolute" style={{ top: '182px', 'left': '705px' }} onClick={()=>this.searchCountry(6)}>
                <div className="position-relative">
                  <div className="countryName">LAOS</div>
                  <div className="position-absolute" style={{ left: '-6px', top: '-1px' }}>
                    <img src="images/slice/1.homepage/map/location.png" />
                  </div>
                </div>
              </div>
              <div className="map-dots position-absolute" style={{ top: '50px', 'left': '800px' }} onClick={()=>this.searchCountry(3)}>
                <div className="position-relative">
                  <div className="countryName">CHINA</div>
                  <div className="position-absolute" style={{ left: '-6px', top: '-1px' }}>
                    <img src="images/slice/1.homepage/map/location.png" />
                  </div>
                </div>
              </div>
              <div className="map-dots position-absolute" style={{ top: '260px', 'left': '670px' }} onClick={()=>this.searchCountry(11)}>
                <div className="position-relative">
                  <div className="countryName">THAILAND</div>
                  <div className="position-absolute" style={{ left: '-6px', top: '-1px' }}>
                    <img src="images/slice/1.homepage/map/location.png" />
                  </div>
                </div>
              </div>
              <div className="map-dots position-absolute" style={{ top: '285px', 'left': '815px' }} onClick={()=>this.searchCountry(14)}>
                <div className="position-relative">
                  <div className="countryName">VIETNAM</div>
                  <div className="position-absolute" style={{ left: '-6px', top: '-1px' }}>
                    <img src="images/slice/1.homepage/map/location.png" />
                  </div>
                </div>
              </div>
              <div className="map-dots position-absolute" style={{ top: '330px', 'left': '730px' }} onClick={()=>this.searchCountry(2)}>
                <div className="position-relative">
                  <div className="countryName">CAMBODIA</div>
                  <div className="position-absolute" style={{ left: '-6px', top: '-1px' }}>
                    <img src="images/slice/1.homepage/map/location.png" />
                  </div>
                </div>
              </div>
              <div className="map-dots position-absolute" style={{ top: '390px', 'left': '670px' }} onClick={()=>this.searchCountry(7)}>
                <div className="position-relative">
                  <div className="countryName">MALAYSIA</div>
                  <div className="position-absolute" style={{ left: '-6px', top: '-1px' }}>
                    <img src="images/slice/1.homepage/map/location.png" />
                  </div>
                </div>
              </div>
              <div className="map-dots position-absolute" style={{ top: '446px', 'left': '710px' }} onClick={()=>this.searchCountry(9)}>
                <div className="position-relative">
                  <div className="countryName">SINGAPORE</div>
                  <div className="position-absolute" style={{ left: '-6px', top: '-1px' }}>
                    <img src="images/slice/1.homepage/map/location.png" />
                  </div>
                </div>
              </div>
              <div className="map-dots position-absolute" style={{ top: '500px', 'left': '870px' }} onClick={()=>this.searchCountry(5)}>
                <div className="position-relative">
                  <div className="countryName">INDONESIA</div>
                  <div className="position-absolute" style={{ left: '-6px', top: '-1px' }}>
                    <img src="images/slice/1.homepage/map/location.png" />
                  </div>
                </div>
              </div>
              <div className="map-dots position-absolute" style={{ top: '425px', 'left': '885px' }} onClick={()=>this.searchCountry(1)}>
                <div className="position-relative">
                  <div className="countryName">BRUNEI</div>
                  <div className="position-absolute" style={{ left: '-6px', top: '-1px' }}>
                    <img src="images/slice/1.homepage/map/location.png" />
                  </div>
                </div>
              </div>
              <div className="map-dots position-absolute" style={{ top: '340px', 'left': '1100px' }} onClick={()=>this.searchCountry(10)}>
                <div className="position-relative">
                  <div className="countryName">PHILIPPINES</div>
                  <div className="position-absolute" style={{ left: '-6px', top: '-1px' }}>
                    <img src="images/slice/1.homepage/map/location.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Map;

